/**
 * Календарные даты в ЛОКАЛЬНОЙ таймзоне пользователя.
 *
 * Почему не `new Date().toISOString().slice(0, 10)`: toISOString() отдаёт дату
 * в UTC. Для учителя в UTC+3 (Москва) с 00:00 до 03:00 это «вчера», для
 * UTC-5 (es-локаль, Латинская Америка) вечером — уже «завтра». Оценка или
 * посещаемость, выставленная «на сегодня», попадала в соседний день.
 */

const pad2 = (n: number) => String(n).padStart(2, '0')

/** Локальная календарная дата в формате yyyy-MM-dd. */
export function localIsoDate(d: Date = new Date()): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

/** Локальная дата через n дней от `from` (n может быть отрицательным). */
export function localIsoDateInDays(n: number, from: Date = new Date()): string {
  const d = new Date(from)
  d.setDate(d.getDate() + n)
  return localIsoDate(d)
}

/**
 * Разбирает строку даты. Чистую дату `yyyy-MM-dd` трактует как локальную
 * полночь (а не UTC, как делает `new Date('yyyy-MM-dd')`), иначе — обычный
 * разбор `Date`. Возвращает null для невалидных значений.
 */
export function parseLocalDate(s: string): Date | null {
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (m) return localDateOrNull(Number(m[1]), Number(m[2]), Number(m[3]))
  const date = new Date(s)
  return isNaN(date.getTime()) ? null : date
}

/** Локальная полночь y-m-d или null, если такой даты нет (31.02, 13-й месяц). */
export function localDateOrNull(y: number, month: number, day: number): Date | null {
  const date = new Date(y, month - 1, day)
  // new Date(2024, 1, 31) молча превращается в 2 марта — такие даты невалидны
  if (date.getFullYear() !== y || date.getMonth() !== month - 1 || date.getDate() !== day) return null
  return date
}
